module.exports = __webpack_public_path__ + "img/Impact assessment-Monitoring plan.f7649448.svg";